let navigationInstance: ((path: string) => void) | null = null;

export const setNavigationInstance = (navigate: (path: string) => void) => {
  navigationInstance = navigate;
};
 
export const customNavigate = (path: string) => {
  if (navigationInstance) {
    navigationInstance(path);
  }
}; 